import Toggle from 'UIKit/Toggle'

const ToogleMode = ({ value, onValueChanged }: { value: boolean; onValueChanged: (value: boolean) => void }) => {
  return (
    <Toggle
      width="46px"
      defaultColor="text_disabled"
      checkedColor="text_primary"
      backgroundColor="text_disabled"
      checkedBackgroundColor="primary"
      value={value}
      onValueChanged={onValueChanged}
    />
  )
}

export default ToogleMode
